import type { IconProps } from '../types/IconProps.ts';
export const CircleCheck: IconProps = {
    name: 'CircleCheck',
    children: [
        `<circle cx="12" cy="12" r="10" />`,
        `<path d="m9 13 1.73 1.35a1 1 0 0 0 1.44-.23L15 10" />`,
    ]
};